/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationRemoveRedirectUriRequest
 */
export interface ApplicationRemoveRedirectUriRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationRemoveRedirectUriRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRemoveRedirectUriRequest
     */
    redirectUri?: string | null;
}

/**
 * Check if a given object implements the ApplicationRemoveRedirectUriRequest interface.
 */
export function instanceOfApplicationRemoveRedirectUriRequest(value: object): value is ApplicationRemoveRedirectUriRequest {
    return true;
}

export function ApplicationRemoveRedirectUriRequestFromJSON(json: any): ApplicationRemoveRedirectUriRequest {
    return ApplicationRemoveRedirectUriRequestFromJSONTyped(json, false);
}

export function ApplicationRemoveRedirectUriRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationRemoveRedirectUriRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'redirectUri': json['redirectUri'] === undefined ? undefined : json['redirectUri'] === null ? null : json['redirectUri'],
    };
}

export function ApplicationRemoveRedirectUriRequestToJSON(json: any): ApplicationRemoveRedirectUriRequest {
    return ApplicationRemoveRedirectUriRequestToJSONTyped(json, false);
}

export function ApplicationRemoveRedirectUriRequestToJSONTyped(value?: ApplicationRemoveRedirectUriRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'redirectUri': value['redirectUri'],
    };
}

